import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Box, TextField } from '@mui/material';
import clsx from 'clsx';
import WithErrorMessage from '../withErrorMessage/WithErrorMessage';
import textareaStyles from './textarea.styles';
const Textarea = props => {
    const { id, value, onChange, rawErrors, classes } = props;
    const inputRef = useRef();
    const styles = textareaStyles();
    const handleChange = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    const hasErrors = rawErrors?.length > 0;
    return (_jsx(Box, { className: clsx(styles.root, classes?.root), children: _jsx(WithErrorMessage, { error: hasErrors ? rawErrors[0] : undefined, className: clsx(styles.helper, classes?.helper), "data-test": `${id}:textarea:error`, children: _jsx(TextField, { id: id, fullWidth: true, error: hasErrors, value: value, onChange: handleChange, InputProps: {
                    inputRef: inputRef,
                    inputComponent: 'textarea',
                    classes: {
                        formControl: clsx(styles.formControl, classes?.formControl),
                        root: clsx(styles.inputRoot, classes?.inputRoot),
                        input: clsx(styles.input, classes?.input),
                        error: clsx(styles.error, classes?.error),
                    },
                } }, void 0) }, void 0) }, void 0));
};
export default Textarea;
//# sourceMappingURL=Textarea.js.map